// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"j2-z","dimensionLabel":"k2-z","styleChooserControlWrapper":"l2-z","styleChooserControl":"m2-z","disabled":"n2-z","giftCard":"o2-z","styleChooserText":"p2-z"};